import { Component, OnInit } from '@angular/core';
import { ConfigService } from 'app/services/config/config.service';
import { environment } from 'environments/environment';

@Component({
    selector: 'app-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {
    now : Date = new Date();
    env = environment;

    
    constructor(public configService: ConfigService) { }

    ngOnInit() {}
}
